/**
 * SANAYA — Ritual bundle conversion prompt.
 *
 * On the cart page, checks whether the cart contains every component
 * product of a "ritual" set (defined in the #SanayaRitualSets JSON
 * script tag rendered by sections/main-cart-items.liquid) as its own
 * line item. If so, shows a dismissible banner offering to convert
 * those component lines into the pre-built bundle product.
 *
 * Uses the AJAX Cart API only (/cart.js, /cart/update.js, /cart/add.js)
 * — no app, no Shopify Plus, no Cart Transform Function required.
 * This is a client-side nudge, not an enforced discount: a shopper who
 * ignores the prompt can still check out with the separate items.
 */
(function () {
  var CONTAINER_ID = 'SanayaRitualBundlePrompt';
  var CONFIG_ID = 'SanayaRitualSets';
  var DISMISS_KEY_PREFIX = 'sanaya-ritual-dismissed-';

  function getConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function isDismissed(ritual) {
    try {
      return sessionStorage.getItem(DISMISS_KEY_PREFIX + ritual.bundleVariantId) === '1';
    } catch (e) {
      return false;
    }
  }

  function dismiss(ritual) {
    try {
      sessionStorage.setItem(DISMISS_KEY_PREFIX + ritual.bundleVariantId, '1');
    } catch (e) {
      /* ignore */
    }
  }

  // For a given ritual definition, find one cart line per required
  // component product id (any variant of that product counts). Returns
  // null if any component is missing, or if the bundle itself is
  // already in the cart.
  function findMatch(cart, ritual) {
    var alreadyHasBundle = cart.items.some(function (item) {
      return item.variant_id === ritual.bundleVariantId;
    });
    if (alreadyHasBundle) return null;

    var matchedLines = [];
    for (var i = 0; i < ritual.components.length; i++) {
      var productId = ritual.components[i];
      var line = cart.items.find(function (item) {
        return item.product_id === productId;
      });
      if (!line) return null;
      matchedLines.push(line);
    }
    return matchedLines;
  }

  function convertToBundle(ritual, matchedLines, cardEl) {
    var buttons = cardEl.querySelectorAll('button');
    buttons.forEach(function (btn) {
      btn.disabled = true;
    });

    var updates = {};
    matchedLines.forEach(function (line) {
      updates[line.key] = Math.max(0, line.quantity - 1);
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update failed');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: ritual.bundleVariantId, quantity: 1 }] })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        window.location.reload();
      })
      .catch(function () {
        buttons.forEach(function (btn) {
          btn.disabled = false;
        });
      });
  }

  function buildCard(ritual, matchedLines) {
    var card = document.createElement('div');
    card.className = 'sanaya-ritual-bundle-prompt__card';

    var text = document.createElement('p');
    text.className = 'sanaya-ritual-bundle-prompt__text';
    var label = ritual.savingsLabel ? ' and ' + ritual.savingsLabel : '';
    text.textContent =
      'Your cart has everything in ' + ritual.name + '. Convert these items into the bundle' + label + '?';
    card.appendChild(text);

    var actions = document.createElement('div');
    actions.className = 'sanaya-ritual-bundle-prompt__actions';

    var convertBtn = document.createElement('button');
    convertBtn.type = 'button';
    convertBtn.className = 'sanaya-ritual-bundle-prompt__convert button button--primary';
    convertBtn.textContent = 'Convert to ' + ritual.name;
    convertBtn.addEventListener('click', function () {
      convertToBundle(ritual, matchedLines, card);
    });
    actions.appendChild(convertBtn);

    var dismissBtn = document.createElement('button');
    dismissBtn.type = 'button';
    dismissBtn.className = 'sanaya-ritual-bundle-prompt__dismiss link';
    dismissBtn.textContent = 'No thanks';
    dismissBtn.addEventListener('click', function () {
      dismiss(ritual);
      refresh();
    });
    actions.appendChild(dismissBtn);

    card.appendChild(actions);
    return card;
  }

  function render(container, matches) {
    container.innerHTML = '';
    if (matches.length === 0) {
      container.hidden = true;
      return;
    }
    matches.forEach(function (match) {
      container.appendChild(buildCard(match.ritual, match.lines));
    });
    container.hidden = false;
  }

  function refresh() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    var rituals = getConfig();
    if (rituals.length === 0) return;

    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var matches = [];
        rituals.forEach(function (ritual) {
          if (isDismissed(ritual)) return;
          var lines = findMatch(cart, ritual);
          if (lines) matches.push({ ritual: ritual, lines: lines });
        });
        render(container, matches);
      })
      .catch(function () {
        /* ignore — leave prompt as-is on network error */
      });
  }

  var refreshTimer = null;
  function debouncedRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 800);
  }

  document.addEventListener('DOMContentLoaded', refresh);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('quantity__input')) {
      debouncedRefresh();
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (
      target.closest &&
      (target.closest('cart-remove-button') || target.closest('.quantity__button'))
    ) {
      debouncedRefresh();
    }
  });
})();